import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { EmailTemplateManager } from "@/features/admin/components/email-template-manager";
import { PageContainer } from "@/components/ui/page-container";

function AdminEmailPage() {
  return (
    <PageContainer maxWidth="6xl">
      <EmailTemplateManager />
    </PageContainer>
  );
}

export const adminEmailRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email",
  validateSearch: (search: Record<string, unknown>): { new?: true; edit?: string } => {
    const edit =
      typeof search.edit === "string" && search.edit.trim() !== "" ? search.edit : undefined;
    // `edit` tiene prioridad sobre `new` (no tiene sentido ambos a la vez).
    if (edit) {
      return { edit };
    }
    if (search.new === true || search.new === "1" || search.new === "true") {
      return { new: true };
    }
    return {};
  },
  component: AdminEmailPage,
});
